class CustomLayerControl {
  _options: {
    layers: []
  };

  constructor(options) {
    this._options = Object.assign({}, this._options, options)
  }

  addHeading() {
    var heading = document.createElement('h3');
    heading.appendChild(document.createTextNode('Layer Filter'));
    return heading;
  }

  onAdd(map){
    this.map = map;
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl wp-mapbox-gl-js-custom-layer-control';
    this.container.appendChild(this.addHeading());

    var thisCategoryDiv = this._addLayers(this._options.layers);
    this.container.appendChild(thisCategoryDiv);
    return this.container;
  }
  onRemove(){
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
  _addLayers(layers) {
    const el = window.document.createElement('div')
    layers.forEach(function(layer) {
      const innerElement = window.document.createElement('div')
      const input = window.document.createElement('input')
      input.type = "checkbox";
      input.checked = "checked";
      input.name = layer;
      input.value = layer;
      input.id = 'wp-mapbox-gl-js-'+layer;
      input.addEventListener('change',(e)=>{
        if(e.target.checked) {
          this.map.setLayoutProperty(layer,'visibility','visible');
        } else {
          this.map.setLayoutProperty(layer,'visibility','none');
        }
      });
      innerElement.appendChild(input)

      var label = document.createElement('label')
      label.htmlFor = 'wp-mapbox-gl-js-'+layer;;
      label.appendChild(document.createTextNode(layer));
      innerElement.appendChild(label)

      el.appendChild(innerElement);
    }.bind(this));
    return el;
  }

  updateLayers(layers) {
    this.container.innerHTML = '';
    this.container.appendChild(this.addHeading());
    var thisLayerDiv = this._addLayers(layers);
    this.container.appendChild(thisLayerDiv);
  }

}

export default CustomLayerControl;



// WEBPACK FOOTER //
// ./src/components/controls/CustomLayerControl.js